var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _rect4, _rect5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 356,
    viewBox: "0 0 271 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.7871,
    y: 231.659,
    width: 141.705,
    height: 124.121,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1304,
    y: 223.384,
    width: 141.705,
    height: 124.121,
    fill: "#3600CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5542 136.5L134.985 225.97",
    stroke: "black",
    strokeWidth: 1.36694
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.464 225.97L267.895 136.499",
    stroke: "black",
    strokeWidth: 1.36694
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.264 226.533L214.111 134.43",
    stroke: "black",
    strokeWidth: 1.36694
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.425 223.636L67.2331 135.464",
    stroke: "black",
    strokeWidth: 1.36694
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.982 1C60.4335 1 0 61.4335 0 135.982H269.964C269.964 61.4335 209.53 1 134.982 1Z",
    fill: "#14D3A6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.362,
    y: 224.418,
    width: 7.24041,
    height: 123.087,
    fill: "#E4E3E3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 205.836,
    y: 282.342,
    width: 7.24042,
    height: 141.705,
    transform: "rotate(90 205.836 282.342)",
    fill: "#E4E3E3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.439,
    y: 326.818,
    width: 22.7556,
    height: 12.4121,
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2364 135.982C45.5112 58.6129 105.503 14.1016 134.465 1.51709C30.2029 5.24073 1.37913 92.7118 0 135.982H37.2364Z",
    fill: "#3600CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.764 135.465C225.489 58.0958 165.497 13.5845 136.535 1C240.797 4.72364 269.621 92.1947 271 135.465H233.764Z",
    fill: "#3600CE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6108 135.982C83.7826 66.1636 117.94 16.0079 135.5 1.51709C115.33 63.0606 114.296 118.57 115.33 135.982H78.6108Z",
    fill: "#3600CE",
    stroke: "#333333",
    strokeWidth: 0.595416
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.423 135.465C188.252 65.6465 154.094 15.4908 136.534 1C156.704 62.5435 157.738 118.053 156.704 135.465H193.423Z",
    fill: "#3600CE",
    stroke: "#333333",
    strokeWidth: 0.595416
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDelivery);
export default __webpack_public_path__ + "static/media/ServiceDelivery.5a6167fe8206b581d5cf5ef9a00d49e8.svg";
export { ForwardRef as ReactComponent };